import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { RouteProps } from 'react-router';
import { connect } from 'react-redux';

import Path from '@utils/Path';
import { ApplicationState } from 'reducers';
import { UserAllDataFragment } from '@api/graphql/types';

type Props = {
    user: UserAllDataFragment,
    isLoggedIn: boolean,
    permissions: string[],
    requireRole: string[];
} & RouteProps;

class PrivateRoute extends React.Component<Props> {
    public render() {
        const { component: Component, isLoggedIn, user, requireRole, permissions, ...rest } = this.props;
        return (
            <Route
                {...rest}
                render={(props) => {
                    if (isLoggedIn) {
                        // @ts-ignore
                        if (user && requireRole && !requireRole.every(role => permissions.includes(role))) {
                            return <Redirect to={{ pathname: Path.dashboard }} />;
                        } else {
                            return (Component ? <Component {...props} /> : this.props.render && this.props.render(props));
                        }
                    } else {
                        return <Redirect to={{ pathname: Path.login, state: {from: this.props.location!.pathname} }} />;
                    }
                }}
             />
        );
    }
}

const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        isLoggedIn: !!auth.user,
        user: auth.user,
        permissions: auth.permissions,
    };
};

export default connect(mapStateToProps)(PrivateRoute);




// WEBPACK FOOTER //
// ./src/components/Routes/PrivateRoute.tsx